var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mapLoaded
    ? _c("tecno-map", {
        ref: "map",
        attrs: {
          loading: _vm.dataLoading,
          options: _vm.mapOptions,
          section: _vm.section
        },
        on: {
          ready: function($event) {
            return _vm.mapAfterLoad()
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "extra",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mapLoaded,
                          expression: "mapLoaded"
                        }
                      ],
                      staticClass: "tecnomap-container"
                    },
                    [
                      _c("div", { staticClass: "tecnomap-left-sidebar" }, [
                        _vm.mapDrawable
                          ? _c("div", { staticClass: "draw-tools" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "tecnomap-controls-element btn btn-google first",
                                  class: { active: _vm.mapDrawMode == "draw" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.enableDraw("draw")
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "btn-control-map defualt",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/draw-map-list.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map hover",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/draw_map_over.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map selected",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/draw_map_active.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.lang.labels.draw_polygon_list)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "tecnomap-controls-element btn btn-google",
                                  class: { active: _vm.mapDrawMode == "edit" },
                                  attrs: { disabled: !_vm.hasUserPolygons },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.enableDraw("edit")
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "btn-control-map defualt",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/move_map-list.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map hover",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/move_map_over.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map selected",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/move_map_active.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.lang.labels.move_polygon_list)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "tecnomap-controls-element btn btn-google",
                                  class: {
                                    active: _vm.mapDrawMode == "delete"
                                  },
                                  attrs: { disabled: !_vm.hasUserPolygons },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.enableDraw("delete")
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "btn-control-map defualt",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/delete_map-list.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map hover",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/delete_map_over.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map selected",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/delete_map_active.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.lang.labels.delete_polygon_list
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "tecnomap-controls-element btn btn-google",
                                  class: { active: _vm.isGeolocating },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.locate()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "btn-control-map defualt",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/geo_map-list.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map hover",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/geo_map_over.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "btn-control-map selected",
                                    attrs: {
                                      src:
                                        "/img/icons/" +
                                        _vm.$root.network +
                                        "/geo_map_active.svg"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "geoloc" }, [
                                    _vm._v(_vm._s(_vm.lang.labels.geoloc))
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "zoom-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "tecnomap-controls-element btn zoom-in",
                              attrs: { disabled: _vm.mapLimits.zoomIn },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.zoomIn()
                                }
                              }
                            },
                            [_vm._v("+")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "tecnomap-controls-element btn zoom-out",
                              attrs: { disabled: _vm.mapLimits.zoomOut },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.zoomOut()
                                }
                              }
                            },
                            [_vm._v("–")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.section == "estate" && _vm.allEstatesEnabled
                        ? _c("div", { staticClass: "all-estates-cont" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "tecnomap-controls-element btn btn-google all-estates-btn",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.removeBounds()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.lang.labels.all_estates) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config_map.update_list &&
                      _vm.config_map.update_list_button &&
                      _vm.mapFeatures.length > 0
                        ? _c(
                            "div",
                            { staticClass: "tecnomap-interaction form-check" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.mapInteraction,
                                    expression: "mapInteraction"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "map-interaction"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.mapInteraction)
                                    ? _vm._i(_vm.mapInteraction, null) > -1
                                    : _vm.mapInteraction
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.mapInteraction,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.mapInteraction = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.mapInteraction = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.mapInteraction = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "map-interaction" } },
                                [_vm._v(_vm._s(_vm.lang.labels.reload))]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          3348364739
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }